import type { CSSProperties } from "react";
/** Géométrie exacte de l’icône iOS. Les trois plans restent droits, même pendant leur apparition. */
export function BrandSymbol({ reveal = false }: { reveal?: boolean }) {
  return <svg className={`brand-symbol${reveal ? " brand-reveal" : ""}`} viewBox="220 222 584 580" aria-hidden="true">
    <path d="M278 222H804L746 374H220Z" />
    <path d="M278 436H652L594 588H220Z" />
    <path d="M278 650H804L746 802H220Z" />
  </svg>;
}

/** Le contexte choisit le geste du kit ; la boucle ne représente jamais un pourcentage. */
export function MotionLoader({ type = "levels", label, style }: { type?: "levels" | "ribbon" | "clips" | "analysis" | "export"; label?: string; style?: CSSProperties }) {
  const code = { levels: "L1", ribbon: "L2", clips: "L3", analysis: "L4", export: "L5" }[type];
  return <span className={`declic-loader declic-${type}`} data-loader={code} role={label ? "status" : undefined} aria-label={label} aria-hidden={label ? undefined : true} style={style}>
    {type === "clips" ? <><i /><i /><i /></> : type === "ribbon" ? <i /> : type === "analysis" ? <>
      <span className="declic-track">{Array.from({ length: 12 }, (_, i) => <i key={i} />)}</span>
      <span className="declic-lit"><span className="declic-track">{Array.from({ length: 12 }, (_, i) => <i key={i} />)}</span></span>
    </> : <svg viewBox="0 0 584 580" aria-hidden="true">
      <path d="M58 0H584L526 152H0Z" />
      <path d="M58 214H432L374 366H0Z" />
      <path d="M58 428H584L526 580H0Z" />
    </svg>}
  </span>;
}
